/*=========================================================================================
  File Name: moduleContainerManagement.js
  Description: Container Management Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleContainerManagementState.js'
import mutations from './moduleContainerManagementMutations.js'
import actions from './moduleContainerManagementActions.js'
import getters from './moduleContainerManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
